import api from '@/api/language'
import { errorHandler } from "../exports/error_management"

const state = {
    health: null,
    drivers: [],
    items: [],
    items_not_paginated: [],
    pagination: null,
}

const mutations = {
    set(state, payload) {
        state.items = payload
    },
    set_items_not_paginated(state, payload) {
        state.items_not_paginated = payload
    },
    delete(state, id) {
        let index = state.items.findIndex(x => x.id == id)
        state.items.splice(index, 1)
    },
    set_pagination(state, pag) {
        state.pagination = pag
    },
    set_vehicle(state, health) {
        state.health = health
    },
    set_drivers(state, drivers) {
        state.drivers = drivers
    },
   
}

const actions = {
    async sampleExcel() {
        try {
          
       
          const response = await api.sampleExcel();
         
          
          //   const blob = new Blob([response.data], {
          //     type:
          //       "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          //   });
          //   const url = window.URL.createObjectURL(blob);
          //   const link = document.createElement("a");
          //   link.href = url;
          //   link.setAttribute("download", "Language_Settings.xlsx");
          //   document.body.appendChild(link);
          //   link.click();
          //   document.body.removeChild(link);
          //   window.URL.revokeObjectURL(url);
          const base64Data = response.data.file_data.trim();

          // Decode the Base64 string
          const binaryString = window.atob(base64Data);
          const len = binaryString.length;
          const bytes = new Uint8Array(len);

          for (let i = 0; i < len; i++) {
              bytes[i] = binaryString.charCodeAt(i);
          }

          const blob = new Blob([bytes.buffer], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });

          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", response.data.file_name);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        } catch (err) {
          console.error("Error fetching request:", err);
        }
      },
      excelImport(_,payload) {
        return api
            .excelImport(payload)
            .then(results => {
                console.log('createdResults', results)
            })
            .catch(err => {
                errorHandler(err)
            })
    },
    fetch(context, payload) {
        console.log('payload-', payload)
        return api
            .fetch(payload.query, payload.page,payload.filters)
            .then(
                ({
                    data: {
                        success: { data: pag },
                    },
                }) => {
                    if(payload.page && payload.page > 0){
                        console.log('pag', pag)
                        let users = pag.data
                        console.log('this is data ------',users);
                        context.commit('set', users)
                            //let pag = result.data.success.data
                        context.commit('set_pagination', {
                            page: pag.current_page,
                            pageSize: pag.per_page,
                            total: pag.total,
                        })
                    } else {
                        console.log('pag', pag)
                        let items = pag

                        context.commit('set_items_not_paginated', items)
                    }
                }
            )
            .catch(err => {
                errorHandler(err)
            })
    },
}

const getters = {}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}